






















import { Component } from "vue-property-decorator";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import { Message } from "@/@types/socket";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import VueEvent from "@/app/core/decorator/VueEvent";
import { loadText } from "@/app/core/utility/FileUtility";

@Component({
  components: { CtrlButton }
})
export default class TermsOfUseWindow extends Mixins<
  WindowVue<{ message: Message }, never>
>(WindowVue) {
  private appServerTermOfUse: string | null = null;
  private webServerTermOfUse: string | null = null;

  @LifeCycle
  public async mounted() {
    await this.init();
    this.appServerTermOfUse = this.windowInfo.args!.message.termsOfUse;
    this.webServerTermOfUse = await loadText("/static/conf/termsOfUse.txt");
  }

  @VueEvent
  private async commit() {
    await this.close();
  }
}
